import { FormErrors } from 'common-front/src/components/form/formErrors';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { WorkflowAction, WorkflowInput, WorkflowTrigger } from 'common/src/generated/types';
import { isNonEmptyArray } from 'common/src/util/array';
import * as React from 'react';
import { WorkflowActionStep } from './steps/workflowActionStep';
import { WorkflowAddAccreditationsStep } from './steps/workflowAddAccreditationsStep';
import { WorkflowCampaignRecipientsStep } from './steps/workflowCampaignRecipientsStep';
import { WorkflowPositionsStep } from './steps/workflowPositionsStep';
import { WorkflowSendCampaignStep } from './steps/workflowSendCampaignStep';
import { WorkflowSetCustomFieldStep } from './steps/workflowSetCustomFieldStep';
import { WorkflowTriggerStep } from './steps/workflowTriggerStep';
import { WorkflowVolunteersSegmentStep } from './steps/workflowVolunteersSegmentStep';
import { WorkflowSeparator } from './workflowSeparator';

interface IUpdateWorkflowStepsProps {
    hasBeenExecuted: boolean;
    isEdit: boolean;
    workflow: WorkflowInput;

    change(name: string, value: any): void;
}

export const UpdateWorkflowSteps = (props: IUpdateWorkflowStepsProps) => {
    const { translate } = useHeavent();
    const data = props.workflow.data;
    const isVolunteersSegmentStepVisible =
        props.workflow.trigger === WorkflowTrigger.VolunteersSegment;
    const isPositionsStepVisible = props.workflow.trigger === WorkflowTrigger.Assigned;
    const isActionStepVisible =
        (props.workflow.trigger === WorkflowTrigger.VolunteersSegment &&
            typeof data.volunteersSegmentId === 'number') ||
        (props.workflow.trigger === WorkflowTrigger.Assigned &&
            (isNonEmptyArray(data.positionsCategoriesIds) ||
                isNonEmptyArray(data.positionsIds) ||
                isNonEmptyArray(data.positionsSlotsIds) ||
                isNonEmptyArray(data.positionsSegmentsIds)));
    const isSendCampaignStepVisible =
        isActionStepVisible &&
        props.workflow.trigger === WorkflowTrigger.VolunteersSegment &&
        props.workflow.action === WorkflowAction.SendCampaign;
    const isCampaignRecipientsVisible =
        isSendCampaignStepVisible && typeof props.workflow.data.campaignId === 'number';
    const isSetCustomFieldStepVisible =
        isActionStepVisible &&
        props.workflow.trigger === WorkflowTrigger.VolunteersSegment &&
        props.workflow.action === WorkflowAction.SetCustomField;
    const isAddAccreditationsStepVisible =
        isActionStepVisible && props.workflow.action === WorkflowAction.AddAccreditations;
    const isDeleteAccreditationsStepVisible =
        isActionStepVisible && props.workflow.action === WorkflowAction.DeleteAccreditations;
    const isEndVisible =
        isSendCampaignStepVisible || isSetCustomFieldStepVisible || isAddAccreditationsStepVisible;

    return (
        <Flex align="center" direction="column">
            <FormErrors />

            <Flex
                css={{
                    background: 'white',
                    bd: true,
                    borderRadius: '50px',
                    padding: '$2 $4'
                }}
            >
                <Box font="gray800 textSm medium">{translate('d_but_41840')}</Box>
            </Flex>

            <WorkflowSeparator />

            <WorkflowTriggerStep isEdit={props.isEdit} />

            {isVolunteersSegmentStepVisible && (
                <>
                    <WorkflowSeparator />

                    <WorkflowVolunteersSegmentStep
                        hasBeenExecuted={props.hasBeenExecuted}
                        isEdit={props.isEdit}
                    />
                </>
            )}

            {isPositionsStepVisible && (
                <>
                    <WorkflowSeparator />

                    <WorkflowPositionsStep isEdit={props.isEdit} />
                </>
            )}

            {isActionStepVisible && (
                <>
                    <WorkflowSeparator />

                    <WorkflowActionStep isEdit={props.isEdit} workflow={props.workflow} />
                </>
            )}

            {isSendCampaignStepVisible && (
                <>
                    <WorkflowSeparator />

                    <WorkflowSendCampaignStep />
                </>
            )}

            {isCampaignRecipientsVisible && (
                <>
                    <WorkflowSeparator />

                    <WorkflowCampaignRecipientsStep workflow={props.workflow} />
                </>
            )}

            {isSetCustomFieldStepVisible && (
                <>
                    <WorkflowSeparator />

                    <WorkflowSetCustomFieldStep change={props.change} workflow={props.workflow} />
                </>
            )}

            {(isAddAccreditationsStepVisible || isDeleteAccreditationsStepVisible) && (
                <>
                    <WorkflowSeparator />

                    <WorkflowAddAccreditationsStep />
                </>
            )}

            {isEndVisible && (
                <>
                    <WorkflowSeparator />

                    <Flex
                        css={{
                            background: 'white',
                            bd: true,
                            borderRadius: '50px',
                            padding: '$2 $4'
                        }}
                    >
                        <Box font="gray800 textSm medium">{translate('fin_60104')}</Box>
                    </Flex>
                </>
            )}
        </Flex>
    );
};
